import type { TrackPoint } from '@groupe-reca/contracts'
import type { GoogleMapInstance, GoogleMapsApi, MapPolyline } from './googleMaps'

/**
 * Trace GPS enregistrée d'une mission, tronçon par tronçon (`segmentTrack`) : jamais de ligne entre deux tronçons,
 * jamais présentée comme un itinéraire calculé. Réutilisable par la future Vue d'ensemble des opérations.
 */
export interface TrackLayer {
  update: (segments: TrackPoint[][]) => void
  destroy: () => void
}

export function createTrackLayer(api: GoogleMapsApi, map: GoogleMapInstance, color = '#38BDF8'): TrackLayer {
  let lines: MapPolyline[] = []
  const clear = () => {
    for (const line of lines) line.setMap(null)
    lines = []
  }
  return {
    update(segments) {
      clear()
      lines = segments
        .filter((segment) => segment.length > 1)
        .map(
          (segment) =>
            new api.Polyline({
              map,
              path: segment.map((point) => ({ lat: point.latitude, lng: point.longitude })),
              strokeColor: color,
              strokeOpacity: 0.9,
              strokeWeight: 5,
              clickable: false,
            }),
        )
    },
    destroy: clear,
  }
}
